<template>
  <div>
    <div v-for="(crac, index) of ['PENGERANG DATA CENTRE']" :key="index">
      <div
        class="text-base text-blue-600 mb-2 font-bold"
        :class="index % 2 === 0 ? '' : 'mt-4'"
      >
        CRAC STATUS: {{ crac }}
      </div>
      <div class="px-5 py-2 rounded border flex justify-between items-center">
        <div class="wrapper w-full">
          <splide :options="slideOptions">
            <splide-slide v-for="slide of 8" :key="slide" class="px-2">
              <div class="flex items-center p-1 border rounded">
                <div
                  class="p-1 rounded-full flex justify-center items-center"
                  :class="
                    slide === 1 && crac === 'THMO SERVER ROOM'
                      ? 'bg-yellow-800'
                      : 'bg-green-600'
                  "
                >
                  <img src="@/assets/images/logo-crac.png" class="h-5" />
                </div>
                <span class="mx-3 text-blue-600">{{
                  index > 0 ? `#${slide}` : `CRAC-${slide}`
                }}</span>
              </div>
            </splide-slide>
          </splide>
        </div>
      </div>
    </div>

    <div>
      <div class="text-base text-blue-600 mb-2 font-bold mt-4">
        A/C STATUS: THMO SERVER ROOM
      </div>
      <div class="py-2 rounded border flex justify-center items-center w-full">
        <div class="flex wrapper w-full justify-center items-center">
          <div v-for="slide of alarmData" :key="slide" class="flex w-full justify-center items-center">
              <div class="flex items-center py-2 border rounded px-3">
                <div
                  class="p-1 w-full rounded-full flex justify-center items-center bg-yellow-800"
									:class="slide.Is_alarm === true ? 'bg-yellow-800' : 'bg-green-600'"
                >
                  <img src="@/assets/images/logo-crac.png" class="h-4" />
                </div>
                <span class="text-blue-600 mx-4">{{
                  slide.Alarm_name.split('THMO TRIP AC').join('')
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
  props: {
    alarmData: {
      type: [Array, Object]
    }
  },
  components: {
    Splide,
    SplideSlide
  },
  data() {
    return {
      slideOptions: {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false
      }
    }
  }
}
</script>
